/*
 * Native Possum — np-shipping.js v1
 * Behaviour for snippets/np-shipping.liquid (see its header): shows the
 * "Shipping to" selector (hidden without JS, when every card shows) and only
 * the chosen destination's card. If the selected value has no card, the
 * "Other countries" card shows.
 * Loaded straight after the snippet's markup (document.currentScript).
 */
(function () {
  'use strict';
  var root = document.currentScript.previousElementSibling;
  if (!root || !root.hasAttribute('data-np-ship')) return;

  var pick = root.querySelector('[data-np-ship-pick]');
  var select = root.querySelector('#npShipCountry');
  var panels = root.querySelectorAll('[data-np-ship-panel]');
  if (!pick || !select || !panels.length) return;

  function show() {
    var code = select.value;
    var found = false;
    panels.forEach(function (p) {
      var on = p.getAttribute('data-np-ship-panel') === code;
      p.hidden = !on;
      if (on) found = true;
    });
    if (!found) {
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-np-ship-panel') !== 'other';
      });
    }
  }

  pick.hidden = false;
  select.addEventListener('change', show);
  show();
})();
